import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Handle, Position, NodeProps, NodeResizer } from 'reactflow';
import { NodeData } from '../types/workflow';

const LoopContainerNode: React.FC<NodeProps<NodeData>> = ({ data, id, selected }) => {
    const action = data.action;
    const iterateOver = action.iterate_over || '';
    const storeCurrentAs = action.store_current_as || '';

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                borderRadius: 12,
                border: selected ? '2.5px solid #E91E63' : '2px dashed #E91E63',
                background: 'rgba(233,30,99,0.06)',
                boxSizing: 'border-box',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <NodeResizer
                color="#E91E63"
                isVisible={selected}
                minWidth={280}
                minHeight={200}
            />
            {/* Top handle for connecting into the loop */}
            <Handle type="target" position={Position.Top} style={{ zIndex: 10 }} />

            {/* Header bar */}
            <div
                style={{
                    padding: '8px 14px',
                    background: '#E91E63',
                    borderRadius: '10px 10px 0 0',
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    flexShrink: 0,
                    cursor: 'grab',
                    userSelect: 'none',
                    pointerEvents: 'all',
                }}
            >
                <span style={{ fontSize: 16 }}>➰</span>
                <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 'bold', fontSize: 12, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                        For Each Loop
                    </div>
                    <div style={{ fontSize: 11, opacity: 0.9 }}>
                        {iterateOver
                            ? <>over <strong>{iterateOver}</strong>{storeCurrentAs ? <> → <strong>{storeCurrentAs}</strong></> : ''}</>
                            : <span style={{ opacity: 0.7 }}>⚙️ Click Settings to configure</span>
                        }
                    </div>
                </div>
                <div style={{ display: 'flex', gap: 4 }}>
                    <button
                        onClick={(e) => { data.onEdit?.(id); }}
                        title="Loop settings"
                        style={{
                            padding: '2px 8px', fontSize: 10, cursor: 'pointer',
                            background: 'rgba(255,255,255,0.25)', border: '1px solid rgba(255,255,255,0.5)',
                            borderRadius: 3, color: 'white', fontWeight: 'bold',
                        }}
                    >
                        ⚙️
                    </button>
                    <button
                        onClick={(e) => { e.stopPropagation(); data.onDelete?.(id); }}
                        title="Delete loop"
                        style={{
                            padding: '2px 8px', fontSize: 10, cursor: 'pointer',
                            background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.4)',
                            borderRadius: 3, color: 'white',
                        }}
                    >
                        🗑️
                    </button>
                </div>
            </div>

            {/* Drop zone hints */}
            <div
                style={{
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    pointerEvents: 'none',
                }}
            >
                <span style={{ fontSize: 11, color: '#E91E63', opacity: 0.45, userSelect: 'none', textAlign: 'center', padding: '0 16px' }}>
                    Drop action nodes here
                </span>
            </div>

            {/* Bottom handle for connecting out of the loop */}
            <Handle type="source" position={Position.Bottom} style={{ zIndex: 10 }} />
        </div>
    );
};

export default LoopContainerNode;
